import React from "react";
import { Badge } from "@/components/Badge/Badge";
import { BillingInvoice } from "../../api/getBillingInvoices/types";
import {
  BILLING_INVOICE_STATUS_COLORS,
  BILLING_INVOICE_STATUS_LABELS,
} from "../../config/billingInvoiceStatuses";

interface BillingInvoiceStatusBadgeProps {
  status: BillingInvoice["status"];
}

const BillingInvoiceStatusBadge: React.FC<BillingInvoiceStatusBadgeProps> = ({
  status,
}) => {
  return (
    <Badge
      className={`font-normal ${BILLING_INVOICE_STATUS_COLORS[status]}`}
      variant="outline"
    >
      {BILLING_INVOICE_STATUS_LABELS[status]}
    </Badge>
  );
};

export default BillingInvoiceStatusBadge;